import { addDays, startOfDay } from "date-fns";

export const getReminderMinDate = (today: Date = new Date()): Date =>
	addDays(startOfDay(today), 1);
